PopupService.$inject = ['$document'];
function PopupService($document) {
    var service = {};
    service.position = function (width, height, target) {
        //taking care of screen size and responsiveness
        var tolerance = 10;
        var elOffset = target.offset();
        var elHeight = target.outerHeight();
        var docHeight = $document.height();
        var docWidth = $document.width();
        var position = { top: 0, left: 0 };
        if ((elOffset.top + elHeight + height + tolerance) > docHeight) {
            position.top = elOffset.top - height;
        }
        else {
            position.top = elOffset.top + elHeight;
        }
        if ((elOffset.left + width + tolerance) > docWidth) {
            position.left = docWidth - tolerance - width;
        }
        else {
            position.left = elOffset.left;
        }
        return position;
    };
    return service;
}
DatetimeHelperService.$inject = [];
function DatetimeHelperService() {
    var service = {};
    service.isValidDate = function (value) {
        //checking if the given value is a date in a format '31/01/2000'
        var pattern = /^(0?[1-9]|[12][0-9]|3[01]).(0?[1-9]|1[012]).(19\d{2}|[2-9]\d{3}).$/;
        var regex = new RegExp(pattern);
        return regex.test(value);
    };
    return service;
}
DatePickerDirective.$inject = [];
function DatePickerDirective() {
    return {
        scope: {
            dt: '=ngModel',
            minDate: '='
        },
        template: require('./views/datepicker.html'),
        link: function (scope) {
            scope.opened = false;
            console.log('dir1');
            scope.toggle = function () {
                scope.opened = !scope.opened;
            };
        }
    };
}
DatePickerInnerDirective.$inject = ['$compile', '$document', 'popupService', 'datetimeHelper'];
function DatePickerInnerDirective($compile, $document, popupService, datetimeHelper) {
    var popupTpl = '<div rc-datepicker-wrapper ng-model="date" ng-change="dateSelection()">' +
        '<div datepicker format-day="d" show-weeks="false" min-date="minDate" date-disabled="disabled(date, mode)"></div>' +
        '</div>';
    return {
        require: 'ngModel',
        scope: {
            open: '=opened',
            minDate: '='
        },
        link: function (scope, element, attrs, ctrl) {
            console.log('dir2');
            var VIEW_FORMAT = 'DD.MM.YYYY.', ESC = 27, DOWN_ARROW = 40;
            scope.disabled = function (date, mode) {
                return (mode === 'day' && date.getDay() === 0);
            };
            var popup = angular.element(popupTpl);
            ctrl.$parsers.unshift(function parseDate(viewValue) {
                if (!viewValue) {
                    ctrl.$setValidity('date', true);
                    return null;
                }
                else {
                    if (viewValue.dpdate) {
                        ctrl.$setValidity('date', true);
                        return moment.utc(viewValue.dpdate).format();
                    }
                    else {
                        if (datetimeHelper.isValidDate(viewValue)) {
                            if (moment(viewValue, VIEW_FORMAT).isValid()) {
                                var selected = moment(viewValue, VIEW_FORMAT).utc();
                                //check min
                                if (scope.minDate) {
                                    var min = moment(scope.minDate).startOf('day').utc();
                                    if (selected.isBefore(min)) {
                                        ctrl.$setValidity('date', false);
                                        return null;
                                    }
                                }
                                ctrl.$setValidity('date', true);
                                return selected.format();
                            }
                            else {
                                //value cannot be converted
                                ctrl.$setValidity('date', false);
                                return null;
                            }
                        }
                        else {
                            //input is not valid
                            ctrl.$setValidity('date', false);
                            return null;
                        }
                    }
                }
            });
            scope.dateSelection = function (dt) {
                if (angular.isDefined(dt)) {
                    //if one of predefined dates is selected (today, tomorrow...)
                    scope.date = dt;
                }
                ctrl.$setViewValue({ dpdate: scope.date, viewdate: moment(scope.date).format(VIEW_FORMAT) });
                ctrl.$render();
                scope.close();
            };
            //select one of predefined dates
            scope.select = function (offset) {
                var day = moment().startOf('day').add(offset, 'days');
                scope.dateSelection(day);
            };
            ctrl.$render = function () {
                element.val(ctrl.$viewValue.viewdate); //set the view
                scope.date = ctrl.$viewValue.dpdate; //set datepicker model
            };
            //handle model changes
            ctrl.$formatters.unshift(function dateFormatter(modelValue) {
                var dpdate, viewdate = 'Invalid Date';
                if (modelValue) {
                    if (moment(modelValue).isValid()) {
                        //formatter pass fine
                        dpdate = moment.utc(modelValue).toDate();
                        viewdate = moment(modelValue).format(VIEW_FORMAT);
                    }
                }
                else {
                    viewdate = '';
                }
                return {
                    dpdate: dpdate,
                    viewdate: viewdate
                };
            });
            var closeOnClick = function (event) {
                var trigBtn = element.parent().find('button');
                var trigIcn = trigBtn.find('span');
                if (scope.open && event.target !== trigBtn[0] && event.target !== trigIcn[0]) {
                    scope.$apply(function () {
                        scope.open = false;
                    });
                }
            };
            scope.$watch('open', function (value) {
                if (value) {
                    $popupWrapper.offset(popupService.position(260, 270, element));
                    scope.$broadcast('datepicker.focus');
                    $document.bind('click', closeOnClick);
                }
                else {
                    $document.unbind('click', closeOnClick);
                }
            });
            var keydown = function (e) {
                scope.keydown(e);
            };
            element.bind('keydown', keydown);
            scope.keydown = function (evt) {
                if (evt.which === ESC) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    scope.close();
                }
                else {
                    if (evt.which === DOWN_ARROW && !scope.open) {
                        scope.open = true;
                    }
                }
            };
            scope.close = function () {
                scope.open = false;
                element[0].focus();
            };
            var $popupWrapper = $compile(popup)(scope);
            popup.remove();
            $document.find('body').append($popupWrapper);
            scope.$on('$destroy', function () {
                $popupWrapper.remove();
                element.unbind('keydown', keydown);
                $document.unbind('click', closeOnClick);
            });
        }
    };
}
DatePickerWrapperDirective.$inject = [];
function DatePickerWrapperDirective() {
    return {
        transclude: true,
        template: require('./views/datepicker-wrapper.html'),
        link: function (scope, element) {
            console.log('dir3');
            element.bind('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
            });
        }
    };
}
angular.module('rinca.core.directives.datepicker', [])
    .service('popupService', PopupService)
    .service('datetimeHelper', DatetimeHelperService)
    .directive('rcDatepicker', DatePickerDirective)
    .directive('rcDatepickerInner', DatePickerInnerDirective)
    .directive('rcDatepickerWrapper', DatePickerWrapperDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/DatepickerDirective.js
// module id = 307
// module chunks = 0